import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { URL_WOOD_EXPORT } from '../../constance/urls';
import { PATH } from '../../routes/Routes';
import * as _ from 'lodash';
import { ellipsisString } from '../../utils/stringFormat';
import { getExportTransactionStatus } from '../../constance/dataTypes';
import ReportExportButton from '../common/ReportExportButton';
import TSTable from '../common/TSTable';
import { Button, List, Popover, Space, DatePicker, Form, Input, Col, Row, Tooltip } from 'antd';
import { FileTextFilled, PrinterFilled } from '@ant-design/icons'
import { DATE_FORMAT, HUMAN_DATE_FORMAT } from '../../constance/strings';
import dayjs from 'dayjs';
import { useDebounce } from 'use-debounce';
import { BLUE_COLOR, GREEN } from '../../constance/color';
import ColorButton from '../common/ColorButton';

export default function ExportTransactionList(props) {
  const history = useHistory();
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const tableRef = React.useRef();
  const { RangePicker } = DatePicker;
  const searchText = Form.useWatch('search', form)
  const date = Form.useWatch('date', form)
  const [debouncedText] = useDebounce(searchText, 500);

  React.useEffect(() => {
    if (tableRef.current) {
      tableRef.current.fetch();
    }
  }, [date, debouncedText])

  const columns = React.useMemo(() => [
    {
      title: t('date'),
      dataIndex: 'created',
      render: (__, original) => new Date(original.created).toLocaleString('en-GB'),
    },
    {
      title: t('export_transactions.sale_order_no'),
      dataIndex: 'sale_order_no',
    },
    {
      title: t('export_transactions.container_no'),
      dataIndex: 'container_no',
    },
    {
      title: t('export_transactions.customer_code'),
      dataIndex: 'customer_code',
    },
    {
      title: t('export_transactions.wood_size'),
      render: (__, original) => {
        const woodSizeList = _.get(original, 'export_wood_sizes', [])
        let groups = woodSizeList.reduce((cnt, cur) => (cnt[cur] = cnt[cur] + 1 || 1, cnt), {});
        const listItems = Object.entries(groups).reduce((data, cur) => [
          ...data,
          <List.Item>{cur[0]} x {cur[1]}</List.Item>
        ], [])
        return (
          <Popover
            content={<List>{listItems}</List>}
            placement='bottomLeft'
          >{<div>{ellipsisString(woodSizeList.join(', '), 26)}</div>}</Popover>
        )
      }
    },
    {
      title: t('status'),
      render: (__, original) => {
        return t(`export_transactions.statuses.${getExportTransactionStatus(original)}`)
      },
    },
    {
      title: () => null,
      dataIndex: 'id',
      render: (__, original) => (
        <div style={{ textAlign: 'center' }}>
          <Space>
            {_.get(original, 'is_completed', false) && (
              <ReportExportButton
                url={`${URL_WOOD_EXPORT.EXPORT_TRANSACTION}${original.id}/report/`}
                params={{ export_type: 'pdf' }}
                color={GREEN}
                variant="outlined"
                content={t('print')}
                icon={<PrinterFilled />}
                title={t('export_transactions.print')}
                size='medium' />
            )}
            <Tooltip placement="bottom" title={t('detail')}>
              <ColorButton
                color='primary'
                variant='outlined'
                override={BLUE_COLOR}
                icon={<FileTextFilled />}
                onClick={() => { history.push(`${PATH.EXPORT_TRANSACTION}${original.id}`) }} />
            </Tooltip>
          </Space>
        </div>
      )
    }
  ], [])

  return (
    <div style={{ textAlign: 'left' }}>

      <Form form={form}>
        <Row gutter={16}>
          <Col sm={24} md={12} lg={6} style={{ width: '100%' }}>
            <Form.Item label={t('searchs.fields.date')} name={"date"}>
              <RangePicker
                format={HUMAN_DATE_FORMAT}
                placeholder={[
                  t('searchs.placeholders.startDate'),
                  t('searchs.placeholders.endDate'),
                ]}
                style={{ width: '100%' }}
              />
            </Form.Item>
          </Col>
          <Col sm={24} md={12} lg={6} style={{ width: '100%' }}>
            <Form.Item label={t('search')} name={"search"}>
              <Input placeholder={t('search')} allowClear />
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <TSTable
        ref={tableRef}
        url={URL_WOOD_EXPORT.EXPORT_TRANSACTION}
        columns={columns}
        params={{
          date_after: _.get(date, 0, null) ? dayjs(date[0]).format(DATE_FORMAT) : null,
          date_before: _.get(date, 1, null) ? dayjs(_.get(date, 1)).format(DATE_FORMAT) : null,
          search: debouncedText,
        }}

      />

    </div>
  )
}